import { render, staticRenderFns } from "./PsychometricAssessment.vue?vue&type=template&id=6152acfe&"
import script from "./PsychometricAssessment.vue?vue&type=script&lang=js&"
export * from "./PsychometricAssessment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports